import React, { useState, useEffect } from 'react';
import amber from './assets/gallery/amber.webp';
import peridot from './assets/gallery/peridot.webp';
import garnet from './assets/gallery/garnet.webp';
import opal from './assets/gallery/opal.webp';
import tanzanite from './assets/gallery/tanzanite.webp';
import lapisLazuli from './assets/gallery/lapisLazuli.webp';
import ruby from './assets/images/ruby.avif';
import sapphire from './assets/images/sapphire.avif';
import citrine from './assets/images/citrine.avif';
import amethyst from './assets/images/amethyst.avif';
import chrysolite from './assets/images/chrysolite.avif';

const Gallery = () => {
  const [showMore, setShowMore] = useState(false);
  const handleLoadMore = () => {
    setShowMore(true);
  };
  const [isAnimated, setIsAnimated] = useState(false);
  const animation = () => {
    setIsAnimated((prew) => !prew);
  };
  return (
    <section id='gallery' className='gallery'>
      <h2>Gallery</h2>
      <div className='gallery__items'>
        <div className='item'>
          <img src={amber} alt='amber' />
          <figcaption> Amber </figcaption>
        </div>
        <div className='item'>
          <img src={peridot} alt='peridot' />
          <figcaption> Peridot </figcaption>
        </div>
        <div className='item'>
          <img src={garnet} alt='garnet' />
          <figcaption> Garnet </figcaption>
        </div>
        <div className='item'>
          <img src={opal} alt='opal' />
          <figcaption> Opal </figcaption>
        </div>
        <div className='item'>
          <img src={tanzanite} alt='tanzanite' />
          <figcaption> Tanzanite </figcaption>
        </div>
        <div className='item'>
          <img src={lapisLazuli} alt='lapisLazuli' />
          <figcaption> Lapis Lazuli </figcaption>
        </div>
        {showMore && (
          <>
            <div className='item'>
              <img src={citrine} alt='citrine' />
              <figcaption> Citrine </figcaption>
            </div>
            <div className='item'>
              <img src={chrysolite} alt='chrysolite' />
              <figcaption> Chrysolite </figcaption>
            </div>
            <div className='item'>
              <img src={amethyst} alt='amethyst' />
              <figcaption> Amethyst </figcaption>
            </div>
            <div className='item'>
              <img src={ruby} alt='ruby' />
              <figcaption> Ruby </figcaption>
            </div>
            <div className='item'>
              <img src={sapphire} alt='sapphire' />
              <figcaption> Sapphire </figcaption>
            </div>
          </>
        )}
      </div>

      {!showMore && (
        <div
          style={{
            textAlign: 'center',
            margin: '40px 0',
          }}
        >
          <button className='buttonShowMore' onClick={handleLoadMore}>
            Show more
          </button>
        </div>
      )}
    </section>
  );
};

export default Gallery;
